<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号"
                ><a-input v-model="queryParam.mobile" placeholder="手机号"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="邮箱"
                ><a-input v-model="queryParam.email" placeholder="邮箱"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="用户昵称"
                  ><a-input v-model="queryParam.nickName" placeholder="用户昵称"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="认证状态">
                  <a-select
                    v-model="queryParam.authSta"
                    placeholder="认证状态"
                    allowClear
                  >
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="I">已认证</a-select-option>
                    <a-select-option value="R">未认证</a-select-option>
                    <a-select-option value="X">取消认证</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="用户类型">
                  <a-select
                    v-model="queryParam.userType"
                    placeholder="用户类型"
                    allowClear
                  >
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="1">普通用户</a-select-option>
                    <!-- <a-select-option value="2">管家</a-select-option> -->
                    <a-select-option value="3">商家</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = {})"
                  >重置</a-button
                >
                <!-- <a-button
                  type="primary"
                  icon="plus"
                  class="button-margin-left"
                  @click="showModal('add')"
                  v-hasAnyPermission="`admin:add`"
                  >新建</a-button
                > -->
                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="nickname" slot-scope="text, record">
          <template>
            <img
              :src="record.imageUrl"
              class="user-head"
              v-if="record.imageUrl"
            />
            {{ text }}
          </template>
        </span>
        <span slot="authsta" slot-scope="text"
          ><a-badge
            :status="text | statusTypeFilter"
            :text="text | statusFilter"
        /></span>
        <span slot="usertype" slot-scope="text">
          <a-tag :color="text == '1' ? '' : text == '2' ? '#2db7f5' : '#f50'">
            {{ text == "1" ? "普通用户" : text == "2" ? "管家" : "商户" }}
          </a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a class="a-action" @click="action(record, 'see')">查看</a>
          </template>
        </span>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";

export default {
  name: "UserList",
  components: {
    STable,
    PageView
  },
  data() {
    // handler
    let handleTelphone = (rule, value, callback) => {
      const mobileRegex = /^[1]([3-9])[0-9]{9}$/.test(value);
      if (value) {
        if (!mobileRegex) {
          callback("请输入正确手机号");
        }
      }
      callback();
    };
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "用户昵称",
          dataIndex: "nickName",
          scopedSlots: { customRender: "nickname" }
        },
        {
          title: "性别",
          dataIndex: "sex"
        },
        {
          title: "手机号",
          dataIndex: "mobile"
        },
        {
          title: "邮箱",
          dataIndex: "email"
        },
        {
          title: "认证状态",
          dataIndex: "authSta",
          scopedSlots: { customRender: "authsta" }
        },
        {
          title: "用户类型",
          dataIndex: "userType",
          scopedSlots: { customRender: "usertype" }
        },
        {
          title: "粉丝数",
          dataIndex: "fans"
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime"
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageUserBase(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  filters: {
    statusFilter(type) {
      let str = "已认证";
      if (type == "R") {
        str = "未认证";
      } else if (type == "X") {
        str = "认证失败";
      }
      return str;
    },
    statusTypeFilter(type) {
      let str = "success";
      if (type == "R") {
        str = "default";
      } else if (type == "X") {
        str = "error";
      }
      return str;
    }
  },
  created() {},
  methods: {
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "see") {
        this.$router.push({
          name: "UserInfo",
          query: {
            info: record
          }
        });
      }
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    }
  }
};
</script>
<style lang="less">
.user-head {
  width: 40px;
  height: 40px;
  margin-right: 5px;
}
</style>
